import React from "react"
import "./container.scss"
export default function Container({ children, bg, ...props }) {
  return (
    <div bg={bg} {...props}>
      <div className={`customcontainer`}>{children}</div>
    </div>
  )
}
